import { designCopy } from "../design/copy.ts";
import { plural } from "../design/format/numbers.ts";

export const wordsCopy = {
  meta: "Meta",
  rotulo: designCopy.metrica,
  custoPor: (resultado: string) => `Custo por ${resultado}`,
  custoPorSemImposto: (resultado: string) => `Custo por ${resultado} sem imposto`,
  horas: { um: "hora", varios: "horas" },
  minutos: { um: "minuto", varios: "minutos" },
  metaValor: (meta: string) => `meta ${meta}`,
  completos: (dias: number, periodo: string) => `Últimos ${dias} dias completos · ${periodo}`,
  nota: {
    incompletos: (dias: string, varios: boolean) =>
      varios
        ? `${dias} ainda não foram lidos inteiros: os números desses dias podem subir.`
        : `${dias} ainda não foi lido inteiro: os números desse dia podem subir.`,
    faltando: (AFonte: string, dias: string, n: number) =>
      `${AFonte} não respondeu para ${dias}: as vendas ${plural(n, "desse dia", "desses dias")} estão faltando, não são zero.`,
    faltandoMeta: (dias: string, n: number) =>
      `O Meta não respondeu para ${dias}: os números ${plural(n, "desse dia", "desses dias")} estão faltando, não são zero.`,
    velho: "desatualizado",
    curta: (dias: string, estado: string) => `${dias} ${estado}`,
  },
};
